import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../main/header/header"
import Footer from '../main/footer/footer'
// __ __ Components/Helpers __ _ //


const Layout = () => {
    return (
        <>
            <Header />
            <Outlet />
            <Footer/>
        </>
    );
};

export default Layout;
